import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import ThemeProvider from "./contexts/ThemeContext";
import reportWebVitals from "./reportWebVitals";
// import store from "./store/store";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import store from "./app/store";
import Loader from "./components/ui/Loader";
import "./styles/index.css";
import "./styles/override.css";

export const keycloak = new Keycloak({
  url: process.env.REACT_APP_AUTH_KEYCLOAK_API!,
  realm: process.env.REACT_APP_REALM!,
  clientId: process.env.REACT_APP_CLIENT_ID!,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{
      onLoad: "login-required",
      pkceMethod: "S256",
      checkLoginIframe: false,
    }}
    LoadingComponent={<Loader />}
  >
    <ThemeProvider>
      <Provider store={store}>
        <Router>
          <App />
        </Router>
      </Provider>
    </ThemeProvider>
  </ReactKeycloakProvider>
  // </React.StrictMode>
);

reportWebVitals();
